(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    function onReady(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
        return;
      }

      callback();
    }

    function setupArticleSection(section) {
      if (!section || section.dataset.articleInitialized === 'true') return;
      section.dataset.articleInitialized = 'true';

      var copyButton = section.querySelector('[data-share-copy]');
      var feedback = section.querySelector('[data-share-feedback]');
      var feedbackTimeout = null;

      if (!copyButton) return;

      copyButton.addEventListener('click', function () {
        var shareUrl = copyButton.getAttribute('data-share-url') || '';
        if (!shareUrl) return;

        function showFeedback(message) {
          if (!feedback) return;

          feedback.textContent = message;
          feedback.classList.remove('visually-hidden');

          window.clearTimeout(feedbackTimeout);
          feedbackTimeout = window.setTimeout(function () {
            feedback.textContent = '';
            feedback.classList.add('visually-hidden');
          }, 1800);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(shareUrl).then(function () {
            showFeedback('Link copied');
          }).catch(function () {
            window.prompt('Copy this link', shareUrl);
          });

          return;
        }

        window.prompt('Copy this link', shareUrl);
      });
    }

    function initializeArticleSections() {
      var sections = document.querySelectorAll('[data-kindrx-article-section]');
      Array.prototype.forEach.call(sections, setupArticleSection);
    }

    onReady(initializeArticleSections);
    document.addEventListener('shopify:section:load', initializeArticleSections);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (function () {
    function onReady(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
        return;
      }

      callback();
    }

    function setupBlogSection(section) {
      if (!section || section.dataset.blogInitialized === 'true') return;
      section.dataset.blogInitialized = 'true';

      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-blog-card]'));
      var filterButtons = Array.prototype.slice.call(section.querySelectorAll('[data-blog-filter]'));
      var loadMoreButton = section.querySelector('[data-blog-load-more]');
      var emptyState = section.querySelector('[data-blog-empty]');
      var heroFilterLink = section.querySelector('[data-blog-hero-filter]');
      var faqItems = Array.prototype.slice.call(section.querySelectorAll('[data-blog-faq-item]'));
      var activeFilter = 'all';
      var visibleCount = 6;
      var loadStep = 3;

      function matchingCards() {
        if (activeFilter === 'all') return cards;

        return cards.filter(function (card) {
          return card.getAttribute('data-category') === activeFilter;
        });
      }

      function renderCards(resetVisibleCount) {
        var matches = matchingCards();

        if (resetVisibleCount) {
          visibleCount = 6;
        }

        cards.forEach(function (card) {
          var shouldShow = matches.indexOf(card) !== -1 && matches.indexOf(card) < visibleCount;
          card.hidden = !shouldShow;
        });

        if (emptyState) {
          emptyState.hidden = matches.length !== 0;
        }

        if (loadMoreButton) {
          loadMoreButton.hidden = matches.length <= visibleCount;
        }
      }

      function clearFaqAnimation(item) {
        if (!item) return;

        if (item.__faqTransitionHandler) {
          item.removeEventListener('transitionend', item.__faqTransitionHandler);
          item.__faqTransitionHandler = null;
        }

        item.style.transitionProperty = '';
        item.style.transitionDuration = '';
        item.style.transitionTimingFunction = '';
        item.style.height = '';
        item.style.overflow = '';
      }

      function animateFaqItem(item, startHeight, endHeight, onComplete) {
        if (!item) return;

        clearFaqAnimation(item);

        if (Math.abs(startHeight - endHeight) < 1) {
          if (onComplete) onComplete();
          return;
        }

        item.style.overflow = 'hidden';
        item.style.height = startHeight + 'px';
        item.offsetHeight;
        item.style.transitionProperty = 'height';
        item.style.transitionDuration = '1400ms';
        item.style.transitionTimingFunction = 'cubic-bezier(0.16, 1, 0.3, 1)';
        item.style.height = endHeight + 'px';

        item.__faqTransitionHandler = function (event) {
          if (event.propertyName !== 'height') return;

          item.removeEventListener('transitionend', item.__faqTransitionHandler);
          item.__faqTransitionHandler = null;

          if (onComplete) onComplete();

          item.style.transitionProperty = '';
          item.style.transitionDuration = '';
          item.style.transitionTimingFunction = '';
          item.style.height = '';
          item.style.overflow = '';
        };

        item.addEventListener('transitionend', item.__faqTransitionHandler);
      }

      function closeFaqItem(item) {
        if (!item || !item.open) return;

        var summary = item.querySelector('summary');
        var startHeight = item.offsetHeight;
        var endHeight = summary ? summary.offsetHeight : 0;
        item.setAttribute('data-faq-collapsing', 'true');

        animateFaqItem(item, startHeight, endHeight, function () {
          item.open = false;
          item.removeAttribute('data-faq-collapsing');

          if (summary) {
            summary.blur();
          }
        });
      }

      function openFaqItem(item) {
        if (!item || item.open) return;

        var startHeight = item.offsetHeight;
        item.removeAttribute('data-faq-collapsing');
        item.open = true;
        animateFaqItem(item, startHeight, item.offsetHeight);
      }

      cards.forEach(function (card) {
        var cardUrl = card.getAttribute('data-blog-card-link');

        if (!cardUrl) return;

        card.addEventListener('click', function (event) {
          if (event.defaultPrevented) return;
          if (event.target.closest('a, button, input, select, textarea, summary, label')) return;

          window.location.href = cardUrl;
        });
      });

      var featuredCardBody = section.querySelector('[data-featured-card-body]');
      if (featuredCardBody) {
        var featuredCardUrl = featuredCardBody.getAttribute('data-featured-card-link');

        if (featuredCardUrl) {
          featuredCardBody.addEventListener('click', function (event) {
            if (event.defaultPrevented) return;
            if (event.target.closest('a, button, input, select, textarea, summary, label')) return;

            window.location.href = featuredCardUrl;
          });
        }
      }

      filterButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var filterValue = button.getAttribute('data-blog-filter') || 'all';
          setActiveFilter(filterValue);
        });
      });

      function setActiveFilter(filterValue) {
        activeFilter = filterValue || 'all';

        filterButtons.forEach(function (item) {
          var isActive = item.getAttribute('data-blog-filter') === activeFilter;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        renderCards(true);
      }

      if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function () {
          visibleCount += loadStep;
          renderCards(false);
        });
      }

      if (heroFilterLink) {
        heroFilterLink.addEventListener('click', function (event) {
          var filterTarget = heroFilterLink.getAttribute('data-blog-hero-filter') || 'research';
          var journalTarget = document.getElementById((heroFilterLink.getAttribute('href') || '').replace('#', ''));
          var matchingButton = null;

          event.preventDefault();

          filterButtons.forEach(function (button) {
            if (button.getAttribute('data-blog-filter') === filterTarget) {
              matchingButton = button;
            }
          });

          if (matchingButton) {
            setActiveFilter(filterTarget);
          }

          if (journalTarget) {
            journalTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }

      faqItems.forEach(function (item) {
        var summary = item.querySelector('summary');

        if (!summary) return;

        summary.addEventListener('click', function (event) {
          event.preventDefault();

          if (item.open) {
            closeFaqItem(item);
            return;
          }

          faqItems.forEach(function (otherItem) {
            if (otherItem !== item && otherItem.open) {
              closeFaqItem(otherItem);
            }
          });

          openFaqItem(item);
        });
      });

      var initialFilter = '';
      try {
        initialFilter = (new URLSearchParams(window.location.search).get('category') || '').toLowerCase();
      } catch (error) {
        initialFilter = '';
      }

      if (initialFilter && ['all', 'news', 'guides', 'research'].indexOf(initialFilter) !== -1) {
        setActiveFilter(initialFilter);
      } else {
        renderCards(true);
      }
    }

    function initializeBlogSections() {
      var sections = document.querySelectorAll('[data-kindrx-blog-section]');
      Array.prototype.forEach.call(sections, setupBlogSection);
    }

    onReady(initializeBlogSections);
    document.addEventListener('shopify:section:load', initializeBlogSections);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-main"]) return;
  try {
    
  (function () {
    var form = document.getElementById('CartForm');
    var notice = document.querySelector('[data-cart-notice]');
    var noticeText = notice ? notice.querySelector('[data-cart-notice-text]') : null;
    var noticeShown = false;
    var noticeTimer = null;

    var applyNoticeStyle = function (type) {
      if (!notice) return;
      notice.classList.remove('cart-notice--success', 'cart-notice--error');
      notice.classList.add(type === 'error' ? 'cart-notice--error' : 'cart-notice--success');
      var checkIcon = notice.querySelector('.cart-notice__icon-check');
      var xIcon = notice.querySelector('.cart-notice__icon-x');
      if (checkIcon && xIcon) {
        if (type === 'error') {
          checkIcon.classList.add('hidden');
          xIcon.classList.remove('hidden');
        } else {
          xIcon.classList.add('hidden');
          checkIcon.classList.remove('hidden');
        }
      }
    };

    var interpolate = function (template, values) {
      if (!template) return '';
      var withBraces = template.replace(/\{(\w+)\}/g, function (match, key) {
        return typeof values[key] === 'string' ? values[key] : '';
      });
      return withBraces.replace(/__([a-z0-9_]+)__/gi, function (match, key) {
        var normalized = String(key || '').toLowerCase();
        return typeof values[normalized] === 'string' ? values[normalized] : '';
      });
    };

    var showNotice = function (type, message) {
      if (!notice || !noticeText || !message) return;
      if (noticeTimer) {
        clearTimeout(noticeTimer);
        noticeTimer = null;
      }
      applyNoticeStyle(type);
      noticeText.textContent = message;
      notice.classList.remove('hidden');
      noticeShown = true;
      noticeTimer = window.setTimeout(function () {
        notice.classList.add('hidden');
      }, 5000);
    };


    var storeNotice = function (type, message) {
      try {
        sessionStorage.setItem('cart_notice', JSON.stringify({ type: type, message: message }));
      } catch (error) {}
    };

    var storedNotice = null;
    try {
      storedNotice = sessionStorage.getItem('cart_notice');
    } catch (error) {}
    if (storedNotice) {
      try {
        var parsed = JSON.parse(storedNotice);
        if (parsed && parsed.message) {
          showNotice(parsed.type || 'info', parsed.message);
        }
      } catch (error) {}
      try {
        sessionStorage.removeItem('cart_notice');
      } catch (error) {}
    }

    if (!form) return;

    var setAllQuantities = function (item, nextValue) {
      if (!item) return;
      var inputs = item.querySelectorAll('[data-qty-input]');
      inputs.forEach(function (input) {
        input.value = String(nextValue);
      });
    };

    form.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var button = target.closest('[data-qty-change], [data-remove-item]');
      if (!button) return;

      var item = button.closest('[data-cart-item]');
      var input = item ? item.querySelector('[data-qty-input]') : null;

      if (button.hasAttribute('data-remove-item') && item) {
        var removeTemplate = form.getAttribute('data-remove-message') || 'Item removed.';
        var itemTitle = item.getAttribute('data-item-title') || '';
        storeNotice('info', interpolate(removeTemplate, { item: itemTitle }));
        setAllQuantities(item, 0);
        form.submit();
        return;
      }

      if (!input) return;

      var current = parseInt(input.value || '0', 10);
      var nextValue = current;

      if (button.hasAttribute('data-qty-increment')) {
        nextValue = Math.max(current + 1, 0);
      } else if (button.hasAttribute('data-qty-decrement')) {
        nextValue = Math.max(current - 1, 0);
      } else {
        return;
      }

      if (nextValue === 0 && item) {
        var removeTemplateOnZero = form.getAttribute('data-remove-message') || 'Item removed.';
        var itemTitleOnZero = item.getAttribute('data-item-title') || '';
        storeNotice('info', interpolate(removeTemplateOnZero, { item: itemTitleOnZero }));
      }
      setAllQuantities(item, nextValue);
      form.submit();
    });

    form.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var convertButton = target.closest('[data-convert-subscription]');
      if (!convertButton) return;

      event.preventDefault();
      if (convertButton.disabled) return;
      convertButton.disabled = true;

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: convertButton.getAttribute('data-line-key'),
          selling_plan: parseInt(convertButton.getAttribute('data-selling-plan'), 10)
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('cart/change failed');
        storeNotice('success', form.getAttribute('data-subscribe-success-message') || 'Subscription applied.');
        window.location.reload();
      }).catch(function () {
        convertButton.disabled = false;
        showNotice('error', form.getAttribute('data-subscribe-error-message') || 'We could not switch this item to a subscription.');
      });
    });

    form.addEventListener('change', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (!target.matches('[data-qty-input]')) return;
      var value = parseInt(target.value || '0', 10);
      if (value === 0) {
        var item = target.closest('[data-cart-item]');
        var removeTemplate = form.getAttribute('data-remove-message') || 'Item removed.';
        var itemTitle = item ? item.getAttribute('data-item-title') || '' : '';
        storeNotice('info', interpolate(removeTemplate, { item: itemTitle }));
      }
      form.submit();
    });

    var applyButton = form.querySelector('[data-promo-apply]');
    if (applyButton) {
      applyButton.addEventListener('click', function () {
        var input = form.querySelector('[data-promo-input]');
        if (!input) return;
        var code = (input.value || '').trim();
        if (!code) return;
        try {
          sessionStorage.setItem('cart_discount_attempt', code);
        } catch (error) {}
        var redirect = '/cart?discount=' + encodeURIComponent(code);
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
      });
    }

    var discountTags = form.querySelector('[data-discount-tags]');
    if (discountTags) {
      discountTags.addEventListener('click', function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;
        var button = target.closest('[data-discount-remove]');
        if (!button) return;
        var removeCode = button.getAttribute('data-discount-code');
        var removeTemplate = form.getAttribute('data-discount-removed-message') || 'Discount removed: {discount}.';
        if (removeCode) {
          storeNotice('error', interpolate(removeTemplate, { discount: removeCode }));
        }
        var codes = Array.prototype.slice.call(discountTags.querySelectorAll('[data-discount-code]')).map(function (el) {
          return el.getAttribute('data-discount-code');
        });
        var remaining = codes.filter(function (code) {
          return code && code !== removeCode;
        });
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        var url = root + 'cart/update.js';
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ discount: remaining.join(',') })
        }).then(function () {
          window.location.reload();
        }).catch(function () {
          window.location.reload();
        });
      });
    }

    var params = new URLSearchParams(window.location.search);
    var attempted = params.get('discount');
    if (!attempted) {
      try {
        attempted = sessionStorage.getItem('cart_discount_attempt');
      } catch (error) {}
    }
    if (attempted) {
      var discountCount = parseInt(form.getAttribute('data-discount-count') || '0', 10);
      var validTemplate = form.getAttribute('data-discount-valid-message') || 'Discount applied: {discount}.';
      var invalidTemplate = form.getAttribute('data-discount-invalid-message') || 'Discount code is not valid: {discount}.';
      if (discountCount > 0) {
        var title = form.getAttribute('data-discount-title') || attempted;
        var successMessage = interpolate(validTemplate, { discount: title });
        if (!noticeShown) showNotice('success', successMessage);
      } else {
        var errorMessage = interpolate(invalidTemplate, { discount: attempted });
        if (!noticeShown) showNotice('error', errorMessage);
      }
      try {
        sessionStorage.removeItem('cart_discount_attempt');
      } catch (error) {}
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var menuOverlay = document.querySelector('[data-menu-overlay]');
    var menuOpenButtons = document.querySelectorAll('[data-menu-open]');
    var menuCloseButtons = document.querySelectorAll('[data-menu-close]');

    var closeMenu = function () {
      if (!menuOverlay) return;
      menuOverlay.classList.remove('animate-slide-down-slow');
      menuOverlay.classList.add('animate-slide-up-slow');
      window.setTimeout(function () {
        menuOverlay.classList.remove('theme-overlay-open', 'animate-slide-up-slow');
        menuOverlay.classList.add('theme-overlay-hidden');
        menuOverlay.setAttribute('aria-hidden', 'true');
        menuOverlay.setAttribute('hidden', '');
      }, 1800);
    };

    var openMenu = function () {
      if (!menuOverlay) return;
      menuOverlay.removeAttribute('hidden');
      menuOverlay.classList.remove('theme-overlay-hidden', 'animate-slide-up-slow');
      menuOverlay.classList.add('theme-overlay-open', 'animate-slide-down-slow');
      menuOverlay.setAttribute('aria-hidden', 'false');
    };

    if (menuOpenButtons.length) {
      menuOpenButtons.forEach(function (button) {
        button.addEventListener('click', openMenu);
      });
    }

    if (menuCloseButtons.length) {
      menuCloseButtons.forEach(function (button) {
        button.addEventListener('click', closeMenu);
      });
    }

    var navDropdownTriggers = document.querySelectorAll('.nav-dropdown-trigger');

    var setDropdownState = function (trigger, isOpen) {
      var button = trigger.querySelector('.nav-link-btn');
      if (!button) return;

      trigger.classList.toggle('is-open', isOpen);
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    };

    var closeAllDropdowns = function (exceptTrigger) {
      navDropdownTriggers.forEach(function (trigger) {
        if (trigger === exceptTrigger) return;
        setDropdownState(trigger, false);
      });
    };

    if (navDropdownTriggers.length) {
      navDropdownTriggers.forEach(function (trigger) {
        var button = trigger.querySelector('.nav-link-btn');
        if (!button) return;

        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          var isOpen = trigger.classList.contains('is-open');
          closeAllDropdowns(trigger);
          setDropdownState(trigger, !isOpen);
        });
      });

      document.addEventListener('click', function (event) {
        if (event.target.closest('.nav-dropdown-trigger')) return;
        closeAllDropdowns();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        closeAllDropdowns();
      });
    }

    document.querySelectorAll('.nav-dropdown-panel a[href*="#"], .header-overlay-item__subnav a[href*="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var url = new URL(link.href, location.origin);
        var targetUrl = url.pathname + url.search + url.hash;
        var isSamePath = url.pathname === location.pathname;
        var isSameSearch = url.search === location.search;
        var isSameHash = url.hash === location.hash;

        if (isSamePath && isSameSearch && isSameHash && url.hash) {
          event.preventDefault();
          var targetSection = document.querySelector(url.hash);

          if (targetSection) {
            targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }

          return;
        }

        if (isSamePath && url.hash) {
          event.preventDefault();
          window.location.assign(targetUrl);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-slider"]) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('[data-products-slider]');
    sections.forEach(function(section) {
      var prev = section.querySelector('[data-slider-prev]');
      var next = section.querySelector('[data-slider-next]');
      var infos = section.querySelectorAll('[data-product-info]');
      var shields = section.querySelectorAll('[data-shield]');
      var track = section.querySelector('[data-slider-track]');
      var count = Math.min(infos.length, track ? track.children.length : 0);
      if (!track || count === 0) return;
      var index = 0;
      var timer;

      function setIndex(nextIndex, direction) {
        index = (nextIndex + count) % count;
        infos.forEach(function(info) {
          info.classList.toggle('is-active', parseInt(info.dataset.index, 10) === index);
        });
        shields.forEach(function(shield) {
          shield.classList.toggle('is-active', parseInt(shield.dataset.index, 10) === index);
        });
        track.classList.remove('is-forward', 'is-back');
        if (direction === 'back') {
          track.classList.add('is-back');
        } else {
          track.classList.add('is-forward');
        }
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
      }

      function nextSlide() { setIndex(index + 1, 'forward'); }
      function prevSlide() { setIndex(index - 1, 'back'); }

      if (next) next.addEventListener('click', function() { nextSlide(); resetTimer(); });
      if (prev) prev.addEventListener('click', function() { prevSlide(); resetTimer(); });

      function resetTimer() {
        if (timer) clearInterval(timer);
        timer = setInterval(nextSlide, 5000);
      }

      setIndex(0, 'forward');
      resetTimer();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
